<template>
  <div id="agingReport">
    <div class="aging-container" style="padding: 20px">
      <div class="header">
        <h3 class="text-left mb-3">Aging Report</h3>
      </div>

      <div id="embedContainer" style="height: 100vh; width: 100%" v-show="pbiIsValid"></div>
      <div v-if="!pbiIsValid" style="text-align: left">
        <!--                <h5 style="color: red;">Server error, please contact administrator!</h5>-->
        <h5 style="color: red">Load PowerBi error, please contact administrator!</h5>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'
import Cookies from 'js-cookie'
import * as pbi from 'powerbi-client'

export default {
  name: 'AgingReport',
  components: {},
  data() {
    return {
      pbiSchID: '',
      pbiToken: '',
      pbiUrl: '',
      pbiReportid: '',
      pbiIsValid: false,
    }
  },
  async created() {
    this.pbiSchID = Cookies.get('schoolSession') // schoolSession
    await this.getPowerbiReportData()
  },
  async mounted() {},
  methods: {
    async getPowerbiReportData() {
      this.$vs.loading()
      try {
        const powerbiRes = await DataSource.shared.getPowerbiEmbedAgingReport()
        if (powerbiRes) {
          if (powerbiRes.ErrorMessage) {
            this.$notify.error({
              title: 'Error',
              message: powerbiRes.ErrorMessage,
            })
          } else {
            this.pbiIsValid = true
            this.pbiToken = powerbiRes.EmbedToken.token
            this.pbiUrl = powerbiRes.EmbedUrl + "&filter=Schools/PK_SCH_ID eq '" + this.pbiSchID + "'"
            this.pbiReportid = powerbiRes.Id

            this.initPowerbiReport()
          }
        }
      } catch (e) {
        console.log(e, 'pbi error')
      }
      this.$vs.loading.close()
    },
    initPowerbiReport() {
      var models = pbi.models

      var config = {
        type: 'report',
        tokenType: models.TokenType.Embed,
        accessToken: this.pbiToken,
        embedUrl: this.pbiUrl,
        id: this.pbiReportid,
        permissions: models.Permissions.All,
        settings: {
          filterPaneEnabled: false,
          navContentPaneEnabled: false,
        },
      }

      var embedContainer = $('#embedContainer')[0]

      var report = powerbi.embed(embedContainer, config)

      // const hiddenBasicFilter = {
      //     $schema: "http://powerbi.com/product/schema#basic",
      //     target: {
      //         table: "Schools",
      //         column: "SCH_Name"
      //     },
      //     operator: "Eq",
      //     values: ['Newton'],
      //     filterType: 1
      //     // displaySettings: {
      //     //     isHiddenInViewMode: true
      //     // }
      // };
      //
      // report.setFilters([hiddenBasicFilter])
      //     .catch(errors => {
      //         // Handle error
      //     });

      report.off('loaded')

      report.on('loaded', function () {
        console.log('Loaded')
        report.getPages().then(function (pages) {
          pages[1].setActive()
        })
      })

      report.off('rendered')

      report.on('rendered', function () {
        console.log('Rendered')
      })

      report.on('error', function (event) {
        console.log(event.detail)
        report.off('error')
      })
    },
  },
}
</script>

<style scoped></style>

<style>
#embedContainer iframe {
  border: none;
}
</style>
